function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search_users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10a2.988 2.988 0 0 1-3-3 2.988 2.988 0 0 1 3-3 2.988 2.988 0 0 1 3 3 2.988 2.988 0 0 1-3 3zm9.438 9.5-2.563-2.562a5 5 0 0 1-.906.406A3.05 3.05 0 0 1 14 17.5a3.486 3.486 0 0 1-3.5-3.5 3.486 3.486 0 0 1 3.5-3.5 3.486 3.486 0 0 1 3.5 3.5 3.05 3.05 0 0 1-.156.969 5 5 0 0 1-.406.906l2.562 2.563zM14 16a1.991 1.991 0 1 0-1.417-.583A1.931 1.931 0 0 0 14 16zm-4.021-4.958a5.255 5.255 0 0 0-.948 2.416A4.833 4.833 0 0 0 9.417 16H3v-2a1.855 1.855 0 0 1 .979-1.646 10.3 10.3 0 0 1 2.906-1.135 9.445 9.445 0 0 1 3.094-.177z",
    transform: "translate(.75 .25)",
    style: {
      fill: "#08232f"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchUsers);
export default __webpack_public_path__ + "static/media/search_users.7d4a0ef474ecc0c4bcc49a0f853dc3d9.svg";
export { ForwardRef as ReactComponent };